import { type JSX, useEffect, useState } from 'react';

/**
 * Updates every minute on the wall-clock minute boundary so the displayed
 * time matches what the OS shows. Skews on first mount land at the next
 * minute tick rather than after a fixed interval — fewer "off by 30s"
 * complaints from sharp-eyed admins.
 */
export function Clock(): JSX.Element {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let cancelled = false;
    function scheduleNext(): void {
      const ms = (60 - new Date().getSeconds()) * 1000 + 50;
      setTimeout(() => {
        if (cancelled) return;
        setNow(new Date());
        scheduleNext();
      }, ms);
    }
    scheduleNext();
    return () => {
      cancelled = true;
    };
  }, []);

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return (
    <span className="clock" data-testid="clock">
      {hours}:{minutes}
    </span>
  );
}
